import React, { useState } from "react";
import AddDept from "../departments/AddDept";
import EditDept from "../departments/EditDept";
// import toast, { Toaster } from "react-hot-toast";
import { Menu, MenuItem } from "@mui/material";
import { api } from "../../utils/axios-instance";
import { useDepartment } from "../../stores/departmentStore";
import { useDarkMode } from "../../context/darkModeContext";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

// images from public folder
const ThreeDots = `${process.env.PUBLIC_URL}/assets/threedots.webp`;

const Departments = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDept, setSelectedDept] = useState(null);
  const { darkMode } = useDarkMode();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const departments = useDepartment((state) => state.departments);
  const listDepartments = useDepartment((state) => state.listDepartments);

  const handleClick = (event, dept) => {
    setAnchorEl(event.currentTarget);
    setSelectedDept(dept);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Open confirm dialog instead of deleting immediately
  const handleRemoveDept = () => {
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    setConfirmOpen(false);
  };

  const confirmDeleteDept = async () => {
    // if (!selectedDept) return;

    // const ok = window.confirm(
    //   `Are you sure you want to delete the "${selectedDept.name}" department?\n\nThis action is permanent — you can't restore the data after.`
    // );

    // if (!ok) {
    //   setAnchorEl(null); // optional: close menu on cancel
    //   return;
    // }

    try {
      const deleteDept = await api.delete(
        `/dept/deleteDept/${selectedDept.id}/`
      );

      if (deleteDept) {
        await listDepartments();
      }

      // close both menu + dialog after success
      setAnchorEl(null);
      setConfirmOpen(false);

      // toast.success(`Department "${selectedDept.name}" deleted successfully`);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="py-3 px-5">
      <div className="flex justify-between ">
        <h3
          className={`text-[20px] font-semibold ${darkMode ? "text-white" : "text-[#111827]"}`}
        >
          Departments
        </h3>
        <AddDept source="settings" />
      </div>

      <hr
        className={`border border-white my-3 ${darkMode ? "border-slate-700" : "border-b-[#D8DEE4]"}`}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 mt-4">
        {departments.map((dept, index) => (
          <div
            key={index}
            className={`py-3 px-4 rounded-2xl flex justify-between items-center min-h-[76px]`}
            style={{
              backgroundColor: `${dept.metadata.bg}80`,
              border: `1px solid ${dept.metadata.border}`,
            }}
          >
            <p
              className={`text-[16px] font-semibold ${darkMode ? "text-white" : "text-[#111827]"}`}
            >
              {dept.name}
            </p>
            <button onClick={(e) => handleClick(e, dept)}>
              <img
                src={ThreeDots}
                alt="..."
                className="h-5 cursor-pointer opacity-70 hover:opacity-100"
              />
            </button>
          </div>
        ))}
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableAutoFocusItem
        PaperProps={{
          style: {
            border: "1px solid [#11182626]",
            boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.1)",
            borderRadius: "6px",
          },
        }}
      >
        <MenuItem style={{ padding: "3px 10px" }}>
          {selectedDept && (
            <EditDept
              id={selectedDept.id}
              name={selectedDept.name}
              color={selectedDept?.metadata?.bg}
            />
          )}
        </MenuItem>

        <MenuItem
          style={{ padding: "3px 10px" }}
          onClick={() => {
            // close the menu first so it doesn't stay open behind dialog
            setAnchorEl(null);
            handleRemoveDept();
          }}
        >
          <p className="text-red-500 text-sm">Discard</p>
        </MenuItem>
      </Menu>

      {/* Custom confirmation dialog (centered, white, styled) */}
      <Dialog open={confirmOpen} onClose={closeConfirm} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: "bold" }}>Delete Department</DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ mt: 1 }}>
            Are you sure you want to delete the{" "}
            <strong>"{selectedDept?.name}"</strong> department?
            <br />
            <br />
            This action is permanent — you can't restore the data after.
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ pb: 2, pr: 3 }}>
          <Button onClick={closeConfirm} variant="outlined">
            Cancel
          </Button>

          <Button onClick={confirmDeleteDept} variant="contained" color="error">
            Delete Permanently
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Departments;
